import { Divider } from '@mui/material';
import { useAtomValue } from 'jotai';
import { BasicDialog } from '../../../../../components/Dialog/BasicDialog';
import { FormFieldsContainer } from '../../../../../components/Form/FormComponents';
import { CompanyLogoAndName } from '../../../../../components/grid-renderers/CompanyCellRenderer';
import { allCompaniesActionStateJ, selectedKpiCompaniesStateDCJ } from '../AllCompaniesStateJ';
import { IManageCompanyFormProps, ManageSingleCompanyForm } from './ManageCompanyForm';
import { useAllKpiCompaniesActions } from './useAllKpiCompaniesActions';

export function ManageModal() {
  const selectedCompany = useAtomValue(selectedKpiCompaniesStateDCJ).at(0);
  const { resetUIState: handleCloseModal } = useAllKpiCompaniesActions();
  const open = useAtomValue(allCompaniesActionStateJ) === 'manage';
  return (
    <BasicDialog open={open} title='Manage Company Settings' onClose={handleCloseModal}>
      {open && (
        <FormFieldsContainer>
          <CompanyLogoAndName name={selectedCompany?.name ?? ''} logoUrl={selectedCompany?.logoUrl ?? ''} />
          <Divider />
          <ManageSingleCompanyForm
            defaultValues={selectedCompany as IManageCompanyFormProps['defaultValues']}
            companyId={selectedCompany!.id}
          />
        </FormFieldsContainer>
      )}
    </BasicDialog>
  );
}
